/**
 * dates.js — the small display-date helpers the case file, the comment thread
 * and the wizard all used to define locally (identical bodies, three copies).
 * Pure, locale-fixed (en-GB), no date library.
 *
 *   formatDate('2026-08-12')                → '12 Aug 2026'   ('—' when empty)
 *   formatDateTime('2026-08-12T09:05:00Z')  → '12 Aug 2026, 09:05' (local time)
 *   isoToDmy('2026-08-12')                  → '12/08/2026'   (non-ISO → echoed)
 */

const SHORT_DATE = { day: 'numeric', month: 'short', year: 'numeric' };
const DATE_TIME  = { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' };
const ISO_DATE_RE = /^(\d{4})-(\d{2})-(\d{2})$/;

/** "12 Aug 2026" — the case-file / comment-thread short date. */
export function formatDate(dt) {
  if (!dt) return '—';
  return new Date(dt).toLocaleDateString('en-GB', SHORT_DATE);
}

/** "12 Aug 2026, 09:05" — comment / history timestamps. */
export function formatDateTime(dt) {
  if (!dt) return '—';
  return new Date(dt).toLocaleString('en-GB', DATE_TIME);
}

/** ISO 'YYYY-MM-DD' → 'dd/mm/yyyy' with no Date parsing (never shifts a day). */
export function isoToDmy(iso) {
  const m = ISO_DATE_RE.exec(String(iso || ''));
  return m ? `${m[3]}/${m[2]}/${m[1]}` : String(iso || '');
}
